import {StyleSheet, View} from 'react-native';
import React, {useEffect, useMemo} from 'react';
import {colors} from 'theme/Colors';
import {spacing} from 'theme/Units';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {RootNavigatorParams} from 'navigation/Routes';
import {selectedProjectID} from 'redux/selectors/projectSelector';
import {useDispatch, useSelector} from 'react-redux';
import {Legend, LegendType} from 'components/common';
import ProgressCircle from 'components/common/circularProgress//ProgressCircle.web';
import {
  getDashboardRequest,
  resetMessage,
} from 'redux/slices/projectAnalyticsSlice';
import {
  projectAnalyticsFaliure,
  projectAnalyticsDashboard,
} from 'redux/selectors/projectAnalyticsSelect';
import {useToast} from 'hooks';
import {ERROR_KEY} from 'constants/keys';
import {ErrorCodes, getErrorMessage} from 'utils/getMessages';
import {getProjectTeamMemberRequest} from 'redux/slices/projectSlice';

export const ProjectStatusScreen = ({
  navigation,
}: NativeStackScreenProps<RootNavigatorParams>) => {
  // when get project details api get fetched we will remove it
  const currentProjectID = useSelector(selectedProjectID);
  const errorDashboard = useSelector(projectAnalyticsFaliure);
  const dashboardStatus = useSelector(projectAnalyticsDashboard);
  const dispatch = useDispatch();
  const {showToasts} = useToast();

  // error message toast
  useEffect(() => {
    if (errorDashboard) {
      showToasts(
        ERROR_KEY,
        getErrorMessage(errorDashboard as ErrorCodes),
        'error',
      );
      dispatch(resetMessage());
    }
  }, [dispatch, showToasts, errorDashboard]);

  useEffect(() => {
    // fetch requrest
    if (currentProjectID) {
      dispatch(getDashboardRequest({id: currentProjectID}));
      dispatch(getProjectTeamMemberRequest({proj_id: currentProjectID}));
    }
  }, [currentProjectID, dispatch]);

  const data: LegendType[] = useMemo<LegendType[]>(
    function () {
      if (dashboardStatus) {
        return [
          {
            color: colors.palette.analytics10,
            label: 'Priority tasks',
            extras: dashboardStatus.priority_task.toString(),
          },
          {
            color: colors.palette.analytics20,
            label: 'Pending tasks',
            extras: dashboardStatus.pending_task.toString(),
          },
          {
            color: colors.palette.analytics30,
            label: 'Overdue tasks',
            extras: dashboardStatus.pending_task.toString(),
          },
          {
            color: colors.palette.analytics40,
            label: 'Upcoming tasks',
            extras: dashboardStatus.upcoming_task.toString(),
          },
        ];
      }
      return [];
    },
    [dashboardStatus],
  );

  return (
    <View style={styles.content}>
      {/* main content */}
      <View style={styles.analytics}>
        <Legend
          data={data}
          fontSize={22}
          tileHeight={22}
          tileWidth={32}
          minWidth={300}
        />
        <ProgressCircle progressPercentage={25} size={200} strokeWidth={22} />
      </View>
    </View>
  );
};
const styles = StyleSheet.create({
  content: {
    flex: 1,
  },
  analytics: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    gap: spacing['16'],
  },
});
